export default __webpack_public_path__ + "static/media/step2-6.23ef600d.jpg";